import { useEffect, useState } from "react";

export const panelWidthPolicy = { min: 280, max: 520, left: 320, right: 380 };
export function clampPanelWidth(value: unknown, fallback: number): number {
  return typeof value === "number" && Number.isFinite(value)
    ? Math.max(panelWidthPolicy.min, Math.min(panelWidthPolicy.max, value)) : fallback;
}

export function useWorkspaceWidths(key: string, defaultLeft = panelWidthPolicy.left) {
  const [widths, setWidths] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(key) || "null");
      return { left: clampPanelWidth(saved?.left, defaultLeft), right: clampPanelWidth(saved?.right, panelWidthPolicy.right) };
    } catch { return { left: defaultLeft, right: panelWidthPolicy.right }; }
  });
  useEffect(() => {
    const timer = window.setTimeout(() => { try { localStorage.setItem(key, JSON.stringify(widths)); } catch { /* Resizing also works when storage is unavailable. */ } }, 250);
    return () => clearTimeout(timer);
  }, [key, widths]);
  return [widths, setWidths] as const;
}
